<template>
    <RadioCardList
        :items="items"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>
<script>
import RadioCardList from '../../../../components/new/card/RadioCardList.vue';

export default {
    name: "ProductsSelectionStep",
    components: { RadioCardList },
    props: {
        selectedProductsCount: {
            type: Number,
            required: true
        },
        totalProductsCount: {
            type: Number,
            required: true
        },
        modelValue: {
            type: Object,
            default: null
        }
    },
    emits: ['update:modelValue', 'update:isReadyForNext'],
    computed: {
        items() {
            return [
                {
                    value: 'selected',
                    label: this.$t('labels.create_selected_products_count', { count: this.selectedProductsCount }),
                    disabled: this.selectedProductsCount === 0
                },
                {
                    value: 'all',
                    label: this.$t('labels.connect_all_products_count', { count: this.totalProductsCount }),
                    disabled: this.totalProductsCount === 0
                }
            ];
        },
        isReadyForNext() {
            return !!this.modelValue;
        }
    },
    watch: {
        isReadyForNext: {
            immediate: true,
            handler(val) {
                this.$emit('update:isReadyForNext', val);
            }
        }
    }
}
</script>
